/**
 * 门户文章跨租户请求头解析
 *
 * @module lib/portal-article-tenant
 */

/** 门户文章跨租户标记（拦截器映射为 x-md-global-tenantID） */
export const PORTAL_ARTICLE_TENANT_HEADER = 'x-portal-article-tenant';

/** {@link PORTAL_ARTICLE_TENANT_HEADER} 取值：ICUA 租户 */
export const PORTAL_ARTICLE_TENANT_ICUA = 'icua';

type PortalArticleHeaders = Record<string, string | number | boolean | string[] | undefined>;

/**
 * 将 {@link PORTAL_ARTICLE_TENANT_HEADER} 映射为 `x-md-global-tenantID`
 *
 * @param headers - 即将发出的请求头（就地修改）
 * @param icuaTenantID - ICUA 租户 ID
 */
export const applyPortalArticleTenantHeader = (
  headers: PortalArticleHeaders,
  icuaTenantID: string,
): void => {
  const portalArticleTenant = headers[PORTAL_ARTICLE_TENANT_HEADER];
  if (portalArticleTenant === PORTAL_ARTICLE_TENANT_ICUA && icuaTenantID) {
    // 调用方依赖原请求头对象被就地更新，因此通过别名保留引用语义。
    const mutableHeaders = headers;
    mutableHeaders['x-md-global-tenantID'] = icuaTenantID;
    delete mutableHeaders[PORTAL_ARTICLE_TENANT_HEADER];
  }
};
